import * as S from '@effect/schema/Schema';
export var HtmlBlockConfig = S.struct({
  typename: S.literal('HtmlBlock'),
  id: S.string,
  hash: S.string,
  htmlContent: S.string
});